import { InputTypes, ValueTypes, IFieldDefinition, FieldViews } from 'app/interfaces';
import { Validators } from '@angular/forms';
import { IDataContainerService } from 'app/interfaces/data-container.interface';

const fieldsMap: Map<string, IFieldDefinition> = new Map();

/**
 * Famiglie di metodi di incasso visibili al dominio: filtra le voci standard mostrate nel
 * catalogo (voce di menu "Metodi di incasso") e quindi quelle mappabili sul Server RT.
 * Vuoto = tutte, così nessun dominio si ritrova la lista vuota.
 * Opzioni dal server (config/rt_mappings.php), non duplicate qui.
 */
fieldsMap.set('visible_families', {
	key: 'visible_families',
	name: 'Metodi di incasso visibili',
	inputType: InputTypes.DATASET_MULTISELECT,
	valueType: ValueTypes.ARRAY,
	datasetCode: 'select_options',
	inputHint: 'Lascia vuoto per mostrarli tutti',
	remoteOptions: {
		limit: 100,
		getParams(): any{
			return { options_code: 'rt_payment_method_families' };
		},
		getLabel(option): string{
			if(!option) return '';
			return option.label;
		},
		getValue(option): string{
			if(!option) return '';
			return option.value;
		}
	}
});

fieldsMap.set('scenario', {
	key: 'scenario',
	name: '',
	inputType: InputTypes.HIDDEN,
	valueType: ValueTypes.STRING,
	fieldView: FieldViews.HIDDEN,
	inputRequired: true,
	formValidators: [ Validators.required ],
	defaultValue(dataContainerService: IDataContainerService): any {
		// scenario sul nodo method_payments: il salvataggio fa array_merge, le sottochiavi
		// (paypal, stripe...) restano intatte
		return 'method_payments';
	}
});

export { fieldsMap as paymentMethodCatalogFieldsMap };
